import { InvoiceStatusEnum } from '../enum/common';
import { IBaseOption } from '../interface/common';

export const mockDataStatus: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Open',
    value: 'OPEN',
  },
  {
    label: 'Paid',
    value: 'PAID',
  },
];

export const mockDataStatusInvoice: IBaseOption[] = [
  {
    label: 'Open',
    value: InvoiceStatusEnum.OPEN,
  },
  {
    label: 'Paid',
    value: InvoiceStatusEnum.PAID,
  },
];
